define([
    'text!product-detail/component/feature-item1.html',
    'product-detail/component/images-box',
    'common/utils'
], function(
    tpl,
    ImagesBox,
    Utils
){
    return {
        template: tpl,
        components: {
            ImagesBox: ImagesBox
        },
        props: {
            item: {
                type: Object
            },
            index: {
                type: String
            }
        },
        methods: {
            ln2br: Utils.ln2br
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/feature-item1.js
// module id = 262
// module chunks = 0